module.exports = __webpack_public_path__ + "img/download_cloud.89d58c76.svg";